import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

export const validate = values => {
  const errors = {};
  const { email, ...rest } = values;
  const isChannelSelected = Object.keys(rest).some(key => !!rest[key]);
  if (!isChannelSelected)
    errors.emailTypes = `${translate(
      'please_select_atleast_one_of_the_above',
    )}`;
  return errors;
};

const validationSchema = Yup.object({
  email: Yup.string()
    .email(`${translate('invalid_email_address')}`)
    .matches(
      /^[a-zA-Z0-9.+-_]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      `${translate('invalid_email_address')}`,
    )
    .max(50, `${translate('only_50_characters_are_allowed')}`)
    .required(`${translate('this_field_cannot_be_left_blank')}`),
});

export default validationSchema;
